<template>
  <div class="ws-line-group">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../assets/scss/ws-line-group.scss";
</style>